const getSingleImage = (field) => {
  if (!field || !field.length) {
    return null
  }
  return field[0].url
}

export default getSingleImage